import { deepValue } from '@corratech/pylot-utils'
import { cartItemMapping } from './cartItemMapping'
import { MappingItem } from '../../GTM'
import { CartItemInterface } from '@pylot-data/pylotschema'

export const cartState = (itemMapping = cartItemMapping()): MappingItem => {
    return {
        items: ['items'],
        discountAmount: (data: CartItemInterface) => {
            const totalInclDiscountExclTax = deepValue(
                data,
                ['prices', 'subtotal_with_discount_excluding_tax', 'value'],
                0
            )
            const totalExclTax = deepValue(
                data,
                ['prices', 'subtotal_excluding_tax', 'value'],
                0
            )
            return totalInclDiscountExclTax - totalExclTax
        },
        priceIclTax: ['prices', 'subtotal_including_tax', 'value'],
        taxAmount: ['prices', 'applied_taxes', '0', 'amount', 'value'],
        couponCode: ['applied_coupons', '0', 'code'],
        total: ['prices', 'grand_total', 'value'],
        currencyCode: ['prices', 'grand_total', 'currency'],
        productsDetails: {
            data_source: ['items'],
            mapping: itemMapping,
            strict: true
        }
    }
}
